import React from 'react'
import { withStyles } from 'material-ui/styles'
import Frontpage from 'assets/src/frontpage.png'
import screenshot from 'assets/screenshot.png'
import screenshot2 from 'assets/screenshot2.png'
import { Link } from 'react-router-dom'
import EmailIcon from 'material-ui-icons/Email'
import Button from 'components/Button'
import Typography from 'material-ui/Typography'
import Grid from 'material-ui/Grid'

const styles = theme => ({
  root: {
    backgroundImage: `
    url(${Frontpage}),
    radial-gradient(at 50% 480px, #0871a9, #021438, #021438)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center -480px, center',
    backgroundAttachment: 'fixed',
    textAlign: 'center',
  },
  head: {
    [theme.breakpoints.up('md')]: {
      height: 500,
    },
    overflow: 'hidden',
  },
  bodyInner: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 0px 20px #00000091',
    padding: 60,
    marginBottom: 250,
  },
  body: {
    paddingBottom: 1000,
  },
  title: {
    textTransform: 'uppercase',
    marginBottom: theme.spacing.unit * 6,
  },
  screenshot: {
    '& img': {
      maxWidth: '100%',
    },
  },
  bigButton: {
    marginTop: 60,
    margin: theme.spacing.unit * 2,
  },
  footer: {
    padding: 30,
  },
  footerText: {
    fontSize: '1rem',
  },
  description: {
    [theme.breakpoints.up('md')]: {
      maxWidth: 500,
      textAlign: 'left',
    },
  },
})
const About = ({ classes }) => {
  return (
    <div className={classes.root}>
      <div className={classes.head} />
      <div className={classes.body}>
        <div className={classes.bodyInner}>
          <Typography gutterBottom type="display1" className={classes.title}>
            The crypto asset manager
          </Typography>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12} md={7}>
              <div className={classes.screenshot}>
                <img src={screenshot} alt="screenshot of totalbalance.io" />
                <Typography type="caption">
                  Screenshot of totalbalance dashboard
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={3}>
              <Typography
                gutterBottom
                type="headline"
                className={classes.description}
              >
                Totalbalance enables you to keep track of your cryptocurrencies.
              </Typography>
            </Grid>
          </Grid>
          <Button
            big
            raised
            component={Link}
            color="primary"
            className={classes.bigButton}
            to="/funds"
          >
            Add your first fund
          </Button>
          <Button
            big
            raised
            component={Link}
            color="accent"
            className={classes.bigButton}
            to="/login"
          >
            Sign Up – It’s Free.
          </Button>
        </div>
        <div className={classes.bodyInner}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12} md={3}>
              <Typography gutterBottom type="headline" className={classes.description}>
                Synchronize and manage your funds in a single place
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <div className={classes.screenshot}>
                <img src={screenshot2} alt="screenshot of totalbalance.io" />
                <Typography type="caption">
                  Screenshot of totalbalance funds manager
                </Typography>
              </div>
            </Grid>
          </Grid>
          <Button
            big
            raised
            component={Link}
            color="primary"
            className={classes.bigButton}
            to="/funds"
          >
            Let's go
          </Button>
        </div>
        <div className={classes.bodyInner}>
          <Typography type="display1" className={classes.title}>

            <Button big type="headline" href="mailto:connect@totalbalance.io">
              <EmailIcon style={{marginRight: 14 }}/>
              Leave us a message
            </Button>
          </Typography>
          <Button
            big
            raised
            component={Link}
            color="primary"
            className={classes.bigButton}
            to="/funds"
          >
            And try us
          </Button>
        </div>
      </div>
      <footer className={classes.footer}>
        <Typography className={classes.footerText}>
          © 2017 totalbalance.io
        </Typography>
      </footer>
    </div>
  )
}

export default withStyles(styles)(About)



// WEBPACK FOOTER //
// ./src/components/About.js